// src/Home.js
import React, { useEffect, useState } from "react";
import { Typography, Button, Divider } from "antd";
import SkillsList from "../components/SkillsList";
import Intro from "../components/Intro";
import WorkHistory from "../components/WorkHistory";
import Projects from "../components/Projects";
import Services from "../components/Services";

const { Title, Paragraph } = Typography;

const Home = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 700);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div style={{ padding: !isMobile ? "50px" : "10px" }}>
      <div style={{ height: isMobile ? "20px" : "0px" }} />
      <Intro isMobile={isMobile} />
      <Divider />
      <Services />
      <Divider />
      <Title level={3}>Skills</Title>
      <SkillsList />
      <Divider />
      <Projects />
      <Divider />
      <WorkHistory isMobile={isMobile} />
    </div>
  );
};

export default Home;
